import { StripeMetadata } from "./StripeMetadata";

export class InitPagamentoStripe {

    totale: number;
    metadata: StripeMetadata;

    constructor(
        totale: number,
        metadata: StripeMetadata
    ) {
        this.totale = totale;
        this.metadata = metadata;
    }
}
